import React from 'react'
import '../scss/PrintAllowance.scss'
import moment from 'moment'

export class PrintAllowance extends React.Component {
  render() {
    // Helper to format date in ROC calendar (中華民國)
    const formatROCDate = (dateStr) => {
      const date = moment(dateStr);
      const rocYear = date.year() - 1911;
      return `中華民國${rocYear}年${date.format('MM月DD日')}`;
    };

    return (
      <div className="content">
      <h2 style={{ textAlign: 'center', marginTop: '40px', marginBottom: '40px' }}>營業人銷貨退回、進貨退出或折讓證明單</h2>

      <table>
        <tbody>
        <tr >
          <th className="text-left">買受人統編</th>
          <td colspan="3" className="text-left">{this.props.printInfo.buyer_vat ? this.props.printInfo.buyer_vat : 'N/A'}</td>
        </tr>
        <tr>
          <th className="text-left">營業人名稱</th>
          <td className="text-left">墊腳石國際股份有限公司多媒體網路商城</td>
          <th className="text-left">統一編號</th>
          <td className="text-left">92944857</td>
        </tr>
        <tr>
          <th className="text-left">折讓日期</th>
          <td className="text-left">{formatROCDate(this.props.printInfo.date)}</td>
          <th className="text-left">折讓單號</th>
          <td className="text-left">{this.props.printInfo.idno}</td>
        </tr>
        <tr>
          <th className="text-left">發票日期</th>
          <td className="text-left">{formatROCDate(this.props.printInfo.invoice_date)}</td>
          <th className="text-left">發票號碼</th>
          <td className="text-left">{this.props.printInfo.invoice_no}</td>
        </tr>
        <tr >
          <th className="text-left">發票聯式</th>
          <td colspan="3" className="text-left">電子發票</td>
        </tr>
        </tbody>
      </table>

      <table>
        <thead>
        <tr>
          <th>品名</th>
          <th>數量</th>
          <th>單價</th>
          <th>金額</th>
          <th>營業稅額</th>
        </tr>
        </thead>
        <tbody>
        {this.props.printInfo.invoice_allowance_items.map((item, idx) => (
          <tr key={idx}>
            <td className="text-left">{item.product_name}</td>
            <td>{item.qty}</td>
            <td>{Number(item.unit_price).toLocaleString()}</td>
            <td>{Number(item.amount).toLocaleString()}</td>
            <td>{Number(item.tax_amount).toLocaleString()}</td>
          </tr>
          ))}
        </tbody>
      </table>

      <table>
        <tbody>
        <tr>
          <th className="text-left">總金額</th>
          <td className="text-left">{this.props.printInfo.total_amount}</td>
          <th className="text-left">營業稅</th>
          <td className="text-left">{this.props.printInfo.tax_amount}</td>
        </tr>
        </tbody>
      </table>

      <div className="stamp-area">
        進貨營業人(或原買受人)蓋統一發票專用章
      </div>

      <p style={{ marginTop: 20 }}>註:本證明單係依據原發票辦理退回或折讓，經雙方確認後簽章保存，確屬事實，特此證明。</p>
      </div>
    )
  }
}
